import React, { useState } from "react";
import { withTheme } from "styled-components";
import OutlineButton from "../OutlineButton/OutlineButton";
import PropTypes from "prop-types";

const OutlineExpandTitleButton = (props) => {
  const { text, type, cutAtChar = 5, onClick, ...rest } = props;

  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded(!expanded);

    if (onClick) {
      onClick();
    }
  };

  const expandedText = text || props.children;

  let printText = expandedText;

  if (expandedText.length > cutAtChar) {
    printText = expandedText.slice(0, cutAtChar - 4) + "...";
  }

  return (
    <OutlineButton
      onClick={() => handleClick()}
      {...rest}
      text={text}
      type={type}
    >
      {expanded ? printText : expandedText}
    </OutlineButton>
  );
};

OutlineExpandTitleButton.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(["accent", "danger"]),
};

export default withTheme(OutlineExpandTitleButton);
